import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=368b4dee&lang=pug&"
import script from "./AppTemplate.vue?vue&type=script&lang=ts&"
export * from "./AppTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports